import { AfterViewInit, Component, ElementRef, EventEmitter, Output, inject } from '@angular/core';

@Component({
    selector: 'pincode-input',
    templateUrl: './pincode-input.component.html',
    styleUrls: ['./pincode-input.component.scss']
})
export class PincodeInputComponent implements AfterViewInit {
  private elRef = inject(ElementRef);

  value = '';
  @Output() pcChange : EventEmitter<string>;

  constructor() {
    this.pcChange = new EventEmitter<string>();
  }


  ngAfterViewInit() {
    $(this.elRef.nativeElement).find('input').first().focus();
  }

  onChange(e: Event) {
    try {
      const el = e.target as HTMLInputElement;
      // extract only the first 6 digits in the string:
      el.value = el.value?.split('').filter(c => !isNaN(parseInt(c))).join('').slice(0, 6);
      el.focus();
    } catch(error) {
      console.log(error);
    }
    this.setValue();
  }

  setValue() {
    let value = '';
    $(this.elRef.nativeElement).find('input').each(function() {
      value+= $(this).val();
    });
    if (value != this.value) {
      this.value = value;
      this.pcChange.emit(value);
    }
  }

  onFocus(e: FocusEvent) {
    (<HTMLInputElement>e.target)?.select();
  }
}
